import PropTypes from 'prop-types';
import styled from 'styled-components';

const Iframe = styled.iframe`
  height: 100vh;
  width: 100%;
  border: none;
`;

const Calculator = ({ isScientific, className }) => {
  return (
    <Iframe
      className={className}
      title="calc"
      src={`https://quark.uacdn.net/calculator_v7/Calc/${
        isScientific ? 'scientific' : 'normal'
      }.html`}
    />
  );
};

export default Calculator;

Calculator.propTypes = {
  isScientific: PropTypes.bool,
  className: PropTypes.string
};

Calculator.defaultProps = {
  isScientific: false,
  className: ''
};
